import { useQuery } from '@tanstack/react-query';
import { INCIDENT_DEFAULT_TICKET_FIELDS } from '@elementary/common-ui/constants/queryKeys';
import { fetchDefaultIncidentFields } from 'incidents/api';
import { TicketingIntegration } from 'shared/types';
import { CreateTicketDialog } from 'shared/components/ticketing';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (customFields?: Record<string, any>) => void;
  incidentId: string;
  integration: TicketingIntegration;
  envId: string;
  incidentUrl: string;
  isCreating: boolean;
  error?: Error | null;
};

const IncidentTicketCreateDialog = ({
  open,
  onClose,
  onConfirm,
  incidentId,
  integration,
  envId,
  incidentUrl,
  isCreating,
  error,
}: Props) => {
  const { data: incidentDefaultFields, isLoading: isLoadingDefaults } =
    useQuery({
      queryKey: [
        INCIDENT_DEFAULT_TICKET_FIELDS,
        envId,
        incidentId,
        integration.id,
        incidentUrl,
      ],
      queryFn: () =>
        fetchDefaultIncidentFields(
          envId,
          incidentId,
          integration.id,
          incidentUrl,
        ),
      enabled:
        open && !!envId && !!incidentId && !!incidentUrl && !!integration.id,
      select: (data) => data.default_fields.fields,
    });

  return (
    <CreateTicketDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      integration={integration}
      envId={envId}
      isCreating={isCreating}
      error={error}
      defaultFields={incidentDefaultFields}
      isLoadingDefaults={isLoadingDefaults}
      contextId={incidentId}
    />
  );
};

export default IncidentTicketCreateDialog;
